import { ButtonTheme } from './button-theme';

export const getThemeClasses = (theme: ButtonTheme): string => {
  switch (theme) {
    case ButtonTheme.PRIMARY:
      return 'bg-primary-700 hover:bg-primary-600 focus:bg-primary-800 active:bg-primary-800 border border-primary-700 hover:border-primary-600 focus:border-primary-800 active:border-primary-800 text-white text-sm';
    case ButtonTheme.SECONDARY:
      return 'bg-secondary-400 hover:bg-secondary-300 focus:bg-primary-500 active:bg-primary-500 border border-primary-400 hover:border-primary-300 focus:border-primary-600 active:border-primary-600 text-white text-sm';
    case ButtonTheme.CREATE:
      return 'bg-tertiary-600 hover:bg-tertiary-400 focus:bg-tertiary-600 active:bg-tertiary-600 border border-tertiary-500 hover:border-tertiary-400 focus:border-tertiary-600 active:border-tertiary-600 text-white text-sm';
    case ButtonTheme.CANCEL:
      return 'bg-white hover:bg-neutral-50 focus:bg-neutral-100 active:bg-neutral-100 border border-neutral-200 hover:border-neutral-400 active:border-neutral-500 focus:border-neutral-500 text-black text-sm';
    case ButtonTheme.SUCCESS:
      return 'bg-[#28a745] hover:bg-[#218838] focus:bg-[#1e7e34] active:bg-[#1e7e34] border border-[#28a745] hover:border-[#218838] focus:border-[#1e7e34] active:border-[#1e7e34] text-white text-sm';
    case ButtonTheme.WARNING:
      return 'text-warning-600 border border-warning-600 hover:bg-warning-100 focus:bg-warning-100 active:bg-warning-100 text-sm';
    case ButtonTheme.ERROR:
      return 'bg-error-100 text-error-300 border border-error-300 hover:bg-error-150 focus:bg-error-150 active:bg-error-200 text-sm';
    case ButtonTheme.MAPZOOM:
      return 'bg-white hover:bg-neutral-50 focus:bg-neutral-100 active:bg-neutral-100 border border-neutral-400 hover:border-neutral-400 active:border-neutral-200 focus:border-neutral-400 text-black text-sm font-semibold';
    case ButtonTheme.MAPRESET:
      return 'bg-white hover:bg-neutral-50 focus:bg-neutral-100 active:bg-neutral-100 border border-neutral-400 hover:border-neutral-400 active:border-neutral-200 focus:border-neutral-400 text-black text-xs';
    case ButtonTheme.MINIMAL:
      return 'text-sm rounded text-center bg-white focus:bg-neutral-100 active:bg-neutral-100 text-black text-sm font-semibold';
    default:
      return 'border';
  }
};

export const getDisabledThemeClasses = (theme: ButtonTheme): string => {
  switch (theme) {
    case ButtonTheme.MINIMAL:
      return ' text-neutral-500 cursor-default';
    default:
      return 'bg-neutral-200 text-neutral-500 border border-white cursor-default';
  }
};
